import * as React from 'react';

const DEFAULT_THRESHOLD = 100;

type UseScrollToBottomResult = {
  isNearBottom: boolean;
  scrollToBottom: (smooth?: boolean) => void;
};

/**
 * Отслеживает, находится ли пользователь внизу чата,
 * и предоставляет функцию для программной прокрутки вниз.
 */
const useScrollToBottom = (
  containerRef: React.RefObject<HTMLElement>,
  threshold: number = DEFAULT_THRESHOLD
): UseScrollToBottomResult => {
  const [isNearBottom, setIsNearBottom] = React.useState(true);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) {
      return;
    }

    const handleScroll = (): void => {
      const nearBottom =
        container.scrollHeight - container.scrollTop - container.clientHeight <
        threshold;
      setIsNearBottom(nearBottom);
    };

    container.addEventListener('scroll', handleScroll, { passive: true });
    return () => container.removeEventListener('scroll', handleScroll);
  }, [containerRef, threshold]);

  const scrollToBottom = React.useCallback(
    (smooth: boolean = true): void => {
      const container = containerRef.current;
      if (!container) {
        return;
      }

      container.scrollTo({
        top: container.scrollHeight,
        behavior: smooth ? 'smooth' : 'auto'
      });
    },
    [containerRef]
  );

  return { isNearBottom, scrollToBottom };
};

export default useScrollToBottom;
